import React from 'react';
import classnames from 'classnames';

export const VBOX = 'mdc-layout-vbox';

export default ({ className, ...props }) => (
  <div
    className={classnames(
      VBOX,
      className,
    )}
    {...props}
  />
);
